<div class="flex flex-col min-h-screen h-screen">
  <div class="bg-quorum-blue shadow-lg z-10 flex flex-row place-content-center align-items-center">
    <div class="h-24 w-full max-w-screen-2xl px-8 flex flex-row place-content-between items-center">
      <a routerLink="gallery" class="flex flex-row place-content-center items-center">
        <img src="assets/Q-ICON-White.png" class="h-16 w-auto">
        <span class="h-full text-4xl ml-3 text-white" style="font-family: 'Montserrat';">Templates</span>
      </a>
      <div class="flex flex-row place-content-end items-center">
        <a routerLink="gallery" class="link">Gallery</a>
        <a routerLink="design" class="link">Design</a>
        <a routerLink="settings" class="link">Settings</a>
        <mat-menu #avatarMenu="matMenu">
          <button id="logout-button" mat-menu-item (click)="logout()">Logout</button>
          <ng-container
            *ngIf="{ selectedLanguage: templateFacade.selectedLanguage$ | async, supportedLanguages: templateFacade.supportedLanguages$ | async} as languageData">
            <button *ngIf="languageData.supportedLanguages.length > 1" mat-menu-item
              [matMenuTriggerFor]="languageMenu">Language</button>
            <mat-menu #languageMenu="matMenu">
              <button [ngClass]="{'text-quorum-blue': language == languageData.selectedLanguage}" mat-menu-item
                *ngFor="let language of languageData.supportedLanguages"
                (click)="setLanguage(language)">{{language}}</button>
            </mat-menu>
          </ng-container>
        </mat-menu>
        <button id="avatar-icon" [matMenuTriggerFor]="avatarMenu" class="h-12 w-12 my-3 ml-2" mat-icon-button>
          <sha-avatar class="w-full h-full" size="large" [displayPresence]="false"
            [avatarUrl]="authenticatedUser.user.avatarUrl"
            [initials]="[authenticatedUser.user.firstName.charAt(0) + authenticatedUser.user.lastName.charAt(0)]">
          </sha-avatar>
        </button>
      </div>
    </div>
  </div>
  <div class="flex-1 flex flex-col overflow-y-auto bg-grey-800">
    <ng-container *ngIf="templateFacade.loadingComplete$ | async as loadingComplete;">
      <mat-progress-bar *ngIf="!loadingComplete" class="w-full fixed" mode="indeterminate">
      </mat-progress-bar>
    </ng-container>
    <div class="flex-1 overflow-auto">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>